import { render } from "./PropostaDocumentoUpload.vue?vue&type=template&id=5e504cd9"
import script from "./PropostaDocumentoUpload.vue?vue&type=script&lang=js"
export * from "./PropostaDocumentoUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__